var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 348,
    viewBox: "0 0 562 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.738 37.525H204.812V310.475H356.738V37.525Z",
    fill: "#FF5A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.926 174C214.926 118.545 240.996 69.326 281 37.525C251.559 14.3769 214.42 0.386719 173.91 0.386719C77.945 0.386719 0.296997 78.035 0.296997 174C0.296997 269.965 77.945 347.614 173.91 347.614C214.42 347.614 251.559 333.623 281 310.475C240.94 279.123 214.926 229.455 214.926 174Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.711 174C561.711 269.965 484.062 347.614 388.098 347.614C347.588 347.614 310.449 333.623 281.008 310.475C321.518 278.618 347.082 229.455 347.082 174C347.082 118.545 321.012 69.326 281.008 37.525C310.393 14.3769 347.532 0.386719 388.041 0.386719C484.062 0.386719 561.711 78.541 561.711 174Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 562,
    height: 348,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.7bdfeae240b2970d513545684563e15c.svg";
export { ForwardRef as ReactComponent };